import { useEffect, useState, type RefObject } from "react";

/**
 * The element's size in CSS pixels, kept current as it changes.
 *
 * The charts draw in pixels rather than a stretched viewBox, so their text and dots stay the same
 * size whatever shape the card is.
 */
export function useElementSize(ref: RefObject<HTMLElement | null>): { width: number; height: number } {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      const width = Math.round(entry.contentRect.width);
      const height = Math.round(entry.contentRect.height);
      setSize((current) =>
        current.width === width && current.height === height ? current : { width, height },
      );
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return size;
}
